export const APP_MESSAGE_CREATOR = 'app-msg.creator'
export const APP_MESSAGE_CREATOR_ADMIN = 'admin'
export const APP_MESSAGE_ROOT_ORG_USERS_GROUP = 'app-msg.user_management.group'
export const APP_MESSAGE_ROOT_ORG_ADMINS_GROUP = 'app-msg.user_management.admin_group'
export const APP_MESSAGE_ROOT_ORG_MANAGE_USERS_ROLE = 'app-msg.user_management.manage_users_role'
export const APP_MESSAGE_ROOT_ORG_READ_ROLE = 'app-msg.user_management.read_role'
export const APP_MESSAGE_ROOT_ORG_WRITE_ROLE = 'app-msg.user_management.write_role'

export const APP_MESSAGE_STA2_LOGMODE = 'drv.sta2.logtype'
export const APP_MESSAGE_STA2_WEIGHT_LOG_ORDER_POINT = 'drv.sta2.weightLOG2.orderpoint'